import { ChainType } from '../types';

const STORAGE_KEY = 'wallet_connection';

interface StoredConnection {
  address: string;
  chainType: ChainType;
}

export const saveConnection = (address: string, chainType: ChainType): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ address, chainType }));
  }
};

export const getStoredConnection = (): StoredConnection | null => {
  if (typeof window !== 'undefined') {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  }
  return null;
};

export const clearConnection = (): void => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(STORAGE_KEY);
  }
};
